import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { TrendingUp } from "lucide-react";

export default function TrendingSidebar() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/news-trending").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <aside className="bg-white rounded-xl border-2 border-slate-100 p-5" data-testid="trending-sidebar">
      <div className="flex items-center gap-2 mb-4 pb-2 border-b-2 border-[#DC2626]">
        <TrendingUp className="w-4 h-4 text-[#DC2626]"/>
        <h3 className="font-devnagri-heading font-black text-lg text-[#0F172A]">आज सबसे पढ़ी गयीं</h3>
      </div>
      <ol className="space-y-3">
        {items.slice(0, 6).map((n, i) => (
          <li key={n.id} className="flex items-start gap-3">
            <div className="text-2xl font-black text-slate-200 shrink-0 leading-none w-6">{i + 1}</div>
            <Link to={`/article/${n.slug}`} className="flex-1 min-w-0 group">
              <div className="text-[10px] uppercase tracking-widest text-[#EA580C] font-bold">{n.category}</div>
              <div className="font-devnagri-heading font-bold text-sm text-[#0F172A] group-hover:text-[#DC2626] line-clamp-2 leading-tight">{n.title}</div>
              <div className="text-[10px] text-slate-400 mt-0.5">{n.views || 0} views</div>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}
